import { v5, singleJobResponseSuccess as mockedSingleJobResponseSuccess } from '@contracts'
import { ApiResponse } from 'hooks/useApi'
import { Dispatch, ReactNode, SetStateAction, createContext, useReducer, useState } from 'react'
import {
  KeywordsAndPhrasesReducerAction,
  KeywordsAndPhrasesReducerState,
} from 'reducers/KeywordsAndPhrasesReducer/KeywordsAndPhrasesReducer.d'
import {
  keywordsAndPhrasesReducer,
  keywordsAndPhrasesReducerInitialState,
} from 'reducers/KeywordsAndPhrasesReducer/KeywordsAndPhrasesReducer'

export interface ViewTaskPageContextProps {
  contentTypeBeingEdited: string | null
  setContentTypeBeingEdited: Dispatch<SetStateAction<string | null>>
  isPageEditable: boolean
  setIsPageEditable: Dispatch<SetStateAction<boolean>>
  isModalOpen: boolean
  setIsModalOpen: Dispatch<SetStateAction<boolean>>
  contentTypeContent: string | string[] | null
  setContentTypeContent: Dispatch<SetStateAction<string | string[] | null>>
  singleJobApiMethods: ApiResponse<v5.JobsDetailData>
  setSingleJobApiMethods: Dispatch<SetStateAction<ApiResponse<v5.JobsDetailData>>>
  keywordsAndPhrasesReducerstate: KeywordsAndPhrasesReducerState
  keywordsAndPhrasesReducerDispatch: Dispatch<KeywordsAndPhrasesReducerAction>
  isResubmitModalOpen: boolean
  setIsResubmitModalOpen: Dispatch<SetStateAction<boolean>>
  shouldShowKeywords: boolean
  setShouldShowKeywords: Dispatch<SetStateAction<boolean>>
}

const initialState: ViewTaskPageContextProps = {
  contentTypeBeingEdited: null,
  setContentTypeBeingEdited: () => {},
  isPageEditable: false,
  setIsPageEditable: () => {},
  isModalOpen: false,
  setIsModalOpen: () => {},
  contentTypeContent: null,
  setContentTypeContent: () => {},
  singleJobApiMethods: {
    fetchData: async () => mockedSingleJobResponseSuccess as v5.JobsDetailData,
    data: null,
    isLoading: false,
    error: null,
    url: new URL('https://example.com'),
    setUrl: () => {},
  },
  setSingleJobApiMethods: () => {},
  keywordsAndPhrasesReducerstate: keywordsAndPhrasesReducerInitialState,
  keywordsAndPhrasesReducerDispatch: () => {},
  isResubmitModalOpen: false,
  setIsResubmitModalOpen: () => {},
  shouldShowKeywords: false,
  setShouldShowKeywords: () => {},
}

export const ViewTaskPageContext = createContext<ViewTaskPageContextProps>(initialState)

interface ViewTaskPageProviderProps {
  children: ReactNode
}
export function ViewTaskPageProvider({ children }: ViewTaskPageProviderProps) {
  const [contentTypeBeingEdited, setContentTypeBeingEdited] = useState<string | null>(
    initialState.contentTypeBeingEdited,
  )
  const [isPageEditable, setIsPageEditable] = useState<boolean>(initialState.isPageEditable)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(initialState.isModalOpen)
  const [contentTypeContent, setContentTypeContent] = useState<string | string[] | null>(null)
  const [singleJobApiMethods, setSingleJobApiMethods] = useState<ApiResponse<v5.JobsDetailData>>(
    initialState.singleJobApiMethods,
  )
  const [keywordsAndPhrasesReducerstate, keywordsAndPhrasesReducerDispatch] = useReducer(
    keywordsAndPhrasesReducer,
    keywordsAndPhrasesReducerInitialState,
  )
  const [isResubmitModalOpen, setIsResubmitModalOpen] = useState<boolean>(initialState.isResubmitModalOpen)
  const [shouldShowKeywords, setShouldShowKeywords] = useState<boolean>(initialState.shouldShowKeywords)

  return (
    <ViewTaskPageContext.Provider
      value={{
        contentTypeBeingEdited,
        setContentTypeBeingEdited,
        isPageEditable,
        setIsPageEditable,
        isModalOpen,
        setIsModalOpen,
        contentTypeContent,
        setContentTypeContent,
        singleJobApiMethods,
        setSingleJobApiMethods,
        keywordsAndPhrasesReducerstate,
        keywordsAndPhrasesReducerDispatch,
        shouldShowKeywords,
        setShouldShowKeywords,
        isResubmitModalOpen,
        setIsResubmitModalOpen,
      }}
    >
      {children}
    </ViewTaskPageContext.Provider>
  )
}

export default ViewTaskPageContext
